import { render, staticRenderFns } from "./ReRegister.vue?vue&type=template&id=6fbd4bb5&scoped=true&"
import script from "./ReRegister.vue?vue&type=script&lang=js&"
export * from "./ReRegister.vue?vue&type=script&lang=js&"
import style0 from "./ReRegister.vue?vue&type=style&index=0&id=6fbd4bb5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd4bb5",
  null
  
)

export default component.exports